import { Icon } from "../../../../components/icon/icon";
import { Pill } from "../../../../components/pill";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";
import { GetSingleUserResponse } from "../../../../redux/features/admin/users/users.types";
import { formatDate } from "../../../../utils/helpers";

export const SingleUserDetails = ({
  user,
  goToEvents = () => {},
  loading = false,
  isPayoutAccVerified = false,
}: {
  user?: GetSingleUserResponse;
  goToEvents?: () => void;
  loading?: boolean;
  isPayoutAccVerified?: boolean;
}) => {
  return (
    <>
      <BgWrapper
        loading={loading}
        loaderHeight={65}
        onClick={goToEvents}
        className="soft-shrink flex cursor-pointer items-center gap-4 text-grey-500"
      >
        <Icon svg="calendar" width={24} height={24} />

        <div className="flex flex-1 flex-col gap-[2px]">
          <p className="text-base font-bold text-grey-900">
            {user?.data.eventsCreated.upcoming ?? "No"} Upcoming Event
            {user?.data.eventsCreated.upcoming === 1 ? "" : "s"}
          </p>
          <p className="text-sm text-grey-600">
            {user?.data.eventsCreated.past ?? "No"} Past Event
            {user?.data.eventsCreated.past === 1 ? "" : "s"}
          </p>
        </div>

        <Icon svg="caret-down" width={24} height={24} className="-rotate-90" />
      </BgWrapper>

      <BgWrapper
        loading={loading}
        loaderHeight={65}
        className="flex items-center gap-4 text-grey-500"
      >
        <Icon svg="padlock" width={24} height={24} />

        <div className="flex flex-1 flex-col gap-[2px]">
          <p className="text-base font-bold text-grey-900">
            Signed up with {user?.data?.signupMethod}
          </p>
          <p className="text-sm text-grey-600">
            Joined on {formatDate(user?.data.dateJoined)}
          </p>
        </div>
      </BgWrapper>

      {user?.data?.organizerType === "Business" && (
        <BgWrapper
          loading={loading}
          loaderHeight={92}
          className="flex items-start gap-4 text-grey-500"
        >
          <img
            alt="organnization"
            src={user?.data?.organisation?.logo}
            className="!size-6 min-h-6 min-w-6 overflow-hidden rounded-full object-cover"
          />

          <div className="flex flex-1 flex-col gap-[2px]">
            <p className="text-base font-bold text-grey-900">
              {user?.data?.organisation?.name}
            </p>
            <p className="text-sm text-grey-600">
              {user?.data?.organisation?.email} ∙ Business
            </p>
            <p className="text-sm text-grey-600">
              {user?.data?.organisation?.phoneNumber}
            </p>
          </div>

          <button type="button" className="w-fit" onClick={() => {}}>
            <Icon svg="pencil" width={20} height={20} className="" />
          </button>
        </BgWrapper>
      )}

      {user?.data?.organizerType === "Business" && (
        <BgWrapper
          loading={loading}
          loaderHeight={65}
          className="flex items-center gap-4 text-grey-500"
        >
          <Icon svg="bank" width={24} height={24} />

          <div className="flex flex-1 flex-col gap-[2px]">
            <p className="text-base font-bold text-grey-900">
              {user?.data?.payoutAccount?.accountName}
            </p>
            <p className="text-sm text-grey-600">
              {user?.data?.payoutAccount?.accountNumber} ∙{" "}
              {user?.data?.payoutAccount?.bankName}
            </p>
          </div>

          {!isPayoutAccVerified && <Pill text="UNVERIFIED" variation="grey" />}
        </BgWrapper>
      )}
    </>
  );
};
